var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import axios from 'axios';
import { CancelablePromise } from 'packages/core/CancelablePromise';
import { AvatarAsset } from 'packages/users/AvatarAsset';
var AvatarAssetRepository = /** @class */ (function (_super) {
    __extends(AvatarAssetRepository, _super);
    function AvatarAssetRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = AvatarAsset;
        _this.url = 'api/v2/uploads';
        _this.timeout = 30000;
        _this.maxFileSize = 1048576 * 50; // 1MB * 50
        return _this;
    }
    AvatarAssetRepository.prototype.uploadAvatarAsset = function (file, userId, progressHandler) {
        var _this = this;
        var formData = new FormData();
        formData.set('file', file);
        formData.set('title', file.name);
        formData.set('uploader_id', userId.toString());
        var cancelSource = axios.CancelToken.source();
        var config = {
            cancelToken: cancelSource.token,
            onUploadProgress: progressHandler,
            timeout: this.timeout,
        };
        var uploadPromise = new CancelablePromise(function (resolve, reject) {
            _this.axios.post(_this.url, formData, config).then(function (response) { return resolve(_this.responseTransformer(response.data)); }).catch(reject);
        });
        uploadPromise.cancel = function () {
            cancelSource.cancel();
            uploadPromise.reject('canceled');
        };
        return uploadPromise;
    };
    return AvatarAssetRepository;
}(AbstractRepository));
export { AvatarAssetRepository };
